export const ICON_SIZE = 26
export const PAGE_SIZE = 10
